import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map } from 'rxjs';

type Locale = 'en' | 'es' | 'fr' | 'de' | 'uk' | 'it' | 'pt' | 'el';
type Dictionary = Record<string, string>;

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLocale: Locale = 'en';
  private dict$ = new BehaviorSubject<Dictionary>({});

  constructor(private http: HttpClient) {
    const saved = (localStorage.getItem('tubify-locale') as Locale) || 'en';
    this.setLocale(saved, false);
  }

  setLocale(locale: Locale, persist = true): void {
    this.currentLocale = locale;
    if (persist) {
      localStorage.setItem('tubify-locale', locale);
    }
    this.http.get<Dictionary>(`/assets/i18n/${locale}.json`).subscribe({
      next: dict => this.dict$.next(dict || {}),
      error: () => this.dict$.next({})
    });
  }

  get locale(): Locale {
    return this.currentLocale;
  }

  translate(key: string): string {
    return this.dict$.value[key] || key;
  }
}
